import { render, staticRenderFns } from "./GrupoUsuario.vue?vue&type=template&id=5810325d&"
import script from "./GrupoUsuario.vue?vue&type=script&lang=js&"
export * from "./GrupoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports